var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
import React, { Children } from "react";
import filterReactProps from "filter-react-props";
import { styled } from "../imports";
import { spaceProp, prop } from "../utils";
import { sizeProps, overflowProps, flexContainerProps } from "../props";
var ListBox = function ListBox(_ref) {
  var children = _ref.children,
    innerRef = _ref.innerRef,
    props = _objectWithoutProperties(_ref, ["children", "innerRef"]);
  return React.createElement("ul", _extends({}, filterReactProps(props), {
    ref: innerRef
  }), Children.map(children, function (item) {
    return React.createElement("li", null, item);
  }));
};
var padding = function padding(val, rawVal, p) {
  if (p.x === true && !p.y) return "padding-left:" + val + ";padding-right:" + val + ";";
  if (!p.x && p.y === true) return "padding-top:" + val + ";padding-bottom:" + val + ";";
  if (!p.x && !p.y) return "padding:" + val + ";";
  return "";
};
var alignX = function alignX(val, p) {
  if (p.alignRight) return "margin-right: -" + val;
  if (p.alignLeft) return "margin-left: -" + val;
  return "";
};
var alignY = function alignY(val, p) {
  if (p.alignTop) return "margin-top: -" + val;
  if (p.alignBottom) return "margin-bottom: -" + val;
  return "";
};
var List = /*#__PURE__*/styled(ListBox, {
  label: "List",
  target: "css-1ggrh30"
})(sizeProps, ";", overflowProps, ";", flexContainerProps, ";", spaceProp(function (val, rawVal, p) {
  return alignX(val, p) + ";" + alignY(val, p) + ";>li>*{" + padding(val, rawVal, p) + " }";
}), ";", prop("x", function (val, rawVal, p) {
  return alignX(val, p) + ";>li>*{padding-left:" + val + ";padding-right:" + val + "}";
}), ";", prop("y", function (val, rawVal, p) {
  return alignY(val, p) + ";>li>*{padding-top:" + val + ";padding-bottom:" + val + "}";
}), ";");
List.displayName = "List";
export default List;